import Base from './Base'

const bundle = {
  Base
}

const install = Vue => {
  Object.values(bundle).forEach(components => {
    Object.values(components).forEach(component => {
      if (!component.name) {
        console.log(
          `[ file path : ${component.__file} ] name attribute is undefined`
        )
      }
      Vue.component(component.name, component)
    })
  })
}
export default install
